import { useEffect, useState } from "react";

export type AirportListItem = {
  name: string;
  city: string;
  country: string;
  iata_code: string;
  _geoloc: {
    lat: number;
    lng: number;
  };
  links_count: number;
  objectID: string;
};

let airportListCache: AirportListItem[] | null = null;
let airportListPromise: Promise<AirportListItem[]> | null = null;

export function loadAirportList() {
  if (airportListCache) {
    return Promise.resolve(airportListCache);
  }

  if (!airportListPromise) {
    airportListPromise = import(
      "@/components/quotes/quotes-template/helpers/airport-list"
    ).then((module) => {
      airportListCache = module.airportList;
      return airportListCache;
    });
  }

  return airportListPromise;
}

export function useAirportList() {
  const [airportList, setAirportList] = useState<AirportListItem[]>([]);

  useEffect(() => {
    void loadAirportList().then(setAirportList);
  }, []);

  return airportList;
}
